import Vue from "vue"
import moment from 'moment';
import 'moment/locale/pt-br';

Vue.filter("formatDate", strdate => moment(strdate).format('DD/MM/YY'))
Vue.filter("formatPrice", value => (value / 1)
  .toFixed(2)
  .replace(/\./, ',')
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
)

